<template>
  <div class="fruitDetail" id="fruitDetail">
    <!-- 页面banner区 -->

    <div class="banner">
      <img :src="info.model.img" />
    </div>
    <div class="wish">
      <!-- 信息展示 -->
      <div class="review_top">
        <div class="review_left">
          <img :src="info.wish.user_avatar" />
        </div>
        <div class="review_center">
          <span class="review_name">{{ info.wish.user_nick }}</span>
          <span class="review_address"
            >{{ info.wish.city }}·{{ info.wish.area }}</span
          >
        </div>
        <div class="review_time">{{ info.wish.date }}</div>
      </div>
      <div class="review_main">
        {{ info.wish.content }}
        <span v-if="info.wish.content && info.wish.content.length == 40"
          >...</span
        >
      </div>
      <div class="review_bottom" v-if="info.wish.imglist">
        <div v-for="(i, index) in info.wish.imglist" :key="index">
          <img :src="i" @click="showPreview($event)" />
        </div>
      </div>
    </div>
    <!-- 心愿信息 -->
    <div class="main">
      <div class="main_contents">
        <div class="main_contents_header">
          <div class="main_contents_header_title">
            {{ info.model.title }}
          </div>
          <div class="main_contents_header_info">
            <span style="margin-right: 4px">时间:{{ info.model.date }}</span>
            <span>编辑:{{ info.model.editor }}</span>
          </div>
        </div>
        <div class="main_contents_box">
          <p v-html="info.model.content"></p>
        </div>
      </div>
    </div>
    <!-- 党员群众有话说 -->
    <div class="people_talks" v-if="info.wish_comment !== null">
      <!-- 背景图 -->
      <img
        class="people_talks_bg1"
        src="http://img.wish.hebyun.com.cn/images/people_talks_bg1.png"
      />
      <img
        class="people_talks_bg2"
        src="http://img.wish.hebyun.com.cn/images/people_talks_bg2.png"
      />
      <div class="party_talks_title">· 党员群众有话说 ·</div>
      <!-- 发布人 -->
      <div
        class="people_talks_box people_talks_left"
        v-if="info.wish_comment.publisher"
      >
        <div class="people_avatars">
          <img
            class="people_avatar"
            :src="info.wish_comment.publisher.avatar"
          />
        </div>
        <div class="people_talks_words">
          <span class="people_name">{{
            info.wish_comment.publisher.nick
          }}</span>
          <div class="people_texts">
            {{ info.wish_comment.publisher.content }}
          </div>
        </div>
      </div>
      <!-- 认领完成人 -->
      <div
        class="people_talks_right people_talks_box"
        v-if="info.wish_comment.claimer"
      >
        <div class="people_talks_words">
          <span class="people_name">{{ info.wish_comment.claimer.nick }}</span>
          <div class="people_texts">
            {{ info.wish_comment.claimer.content }}
          </div>
        </div>
        <div class="people_avatars">
          <img class="people_avatar" :src="info.wish_comment.claimer.avatar" />
          <img
            class="people_party"
            src="http://img.wish.hebyun.com.cn/images/party.png"
          />
        </div>
      </div>
    </div>

    <!-- 心愿完成过程 -->
    <div class="progressTitle" v-if="info.claim_userlist.length > 0">
      · 心愿完成过程 ·
    </div>
    <div class="progress_box" v-if="info.claim_userlist.length > 0">
      <Toggle :list="info.claim_userlist">
        <Progress slot="content" :list="progressList" :isHideMore="true" />
        <van-empty
          class="custom-image"
          description="暂无进度"
          v-if="progressList.length === 0"
          image="http://img.wish.hebyun.com.cn/images/empty_state.png"
        />
      </Toggle>
    </div>
    <!-- 评论区 -->
    <div class="list_comments">
      <div class="list_comments_header">
        <img
          src="http://img.wish.hebyun.com.cn/images/comment_title.png"
          alt=""
        />
      </div>
      <div class="list_comment_items" v-if="commentslist.length != 0">
        <Comment
          :module="'archieve'"
          :id="info.model.id"
          :list="commentslist"
        />
      </div>
      <div class="list_comment_items" v-if="commentslist.length == 0">
        <van-empty
          class="custom-image"
          description="暂无评论,快来抢沙发吧~"
          image="http://img.wish.hebyun.com.cn/images/empty_state.png"
        />
      </div>
      <!-- 查看全部评论 -->
      <div
        class="moreComment"
        v-if="commentslist.length >= 2"
        @click="jumpComments"
      >
        <span>查看全部</span>
        <img
          src="http://img.wish.hebyun.com.cn/images/right_arrow.png"
          alt=""
        />
      </div>
    </div>
    <Footer
      :comment_count="info.comment_count"
      :wishid="info.model.id"
      :pagetype="fruitPage"
      :module="'archieve'"
      :id="info.model.id"
      @refresh="refresh"
    />

    <!-- Loading -->
    <!-- <van-overlay :show="showLoading">
      <van-loading type="spinner" v-if="isLogin()" />
    </van-overlay> -->
    <div class="side_bars">
      <img
        src="http://img.wish.hebyun.com.cn/images/share_icon.png"
        @click="share"
      />
      <img
        src="http://img.wish.hebyun.com.cn/images/return_con.png"
        v-if="isFirstPage"
        @click="goback"
      />
    </div>
  </div>
</template>

<script>
import Toggle from "@/components/Toggle";
import Progress from "@/components/Progress";
import Comment from "@/components/Comment";
import Footer from "@/components/Footer";
import { ImagePreview, Toast } from "vant";

export default {
  name: "fruitDetail",
  components: { Toggle, Progress, Comment, Footer },
  data() {
    return {
      button: "认领",
      id: 0,
      info: {
        model: {},
        wish_comment: {},
        wish: {},
        claim_userlist: [],
      },
      fruitPage: "fruitPage",
      module: "archieve",
      progressList: [],
      currentPartyId: "",
      url: "/comment/pager_list", //评论
      page: 1,
      limit: 3,
      commentslist: [],
      // showLoading: true, //loading
      isFirstPage: false,
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.currentUserId = localStorage.getItem("uid");
    this.queryInfo(this.id);
    this.queryComments();
    let isFirstPage = localStorage.getItem("isFirstPage");
    if (isFirstPage == "0") {
      this.isFirstPage = true;
    }
  },
  mounted() {
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
    });
    document.querySelector("#fruitDetail").scrollIntoView(true);
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    share() {
      var url = window.location.href;

      var msg = {
        shareTitle: "我为群众办实事 党员帮办微心愿",
        shareSummary: "提交心愿、认领心愿、互动点赞，请登录“冀云”客户端",
        shareUrl: url,
        shareImage: "http://img.wish.hebyun.com.cn/images/wyxShare.jpg",
      };
      const u = navigator.userAgent,
        app = navigator.appVersion;
      console.log(app);
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isiOS) {
        window.webkit.messageHandlers.nativeShare.postMessage(
          JSON.stringify(msg)
        );
      } else {
        window.jsInterface.nativeShare(JSON.stringify(msg));
      }
    },
    // 查询成果详情
    async queryInfo(id) {
      let { data } = await this.$api.queryFruitDetail(id);
      this.info = data;
      // this.showLoading = false;
      //  alert(this.info);
      if (this.info.wish.content.length > 40) {
        this.info.wish.content = this.info.wish.content.slice(0, 40);
      }
      // // 查询进度
      if (this.info.claim_userlist.length > 0) {
        this.currentPartyId = this.info.claim_userlist[0].id;
        this.queryProgress(this.info.wish.id, this.currentPartyId);
      }
      Toast.clear();
    },

    // 查询某个心愿中某个党员或机构的进度 wishid:心愿id  user_id:党员或机构用户id，如果0表示当前用户
    async queryProgress(id, user_id) {
      let datas = {
        wishid: id,
        user_id: user_id,
      };
      let { data } = await this.$api.queryProcess(datas);
      this.progressList = data;
    },

    //切换党员
    toggleParty(partyInfo) {
      this.currentPartyId = partyInfo.id;
      this.queryProgress(this.info.wish.id, partyInfo.id);
    },
    // 查询评论
    async queryComments() {
      let { page, limit, url } = this;
      url += `${
        url.indexOf("?") >= 0 ? "&" : "?"
      }page=${page}&limit=${limit}&module=${this.module}&id=${this.id}`;
      let { data } = await this.$api.request(url);
      data.forEach((item) => {
        item.is_thumb = 0;
      });
      this.commentslist = data;
      console.log(this.commentslist);
    },
    // 更新页面
    refresh() {
      this.queryInfo(this.id);
    },

    // 查看全部评论
    jumpComments() {
      this.$router.push({
        path: "./comments",
        query: {
          id: this.id,
          module: "archieve",
        },
      });
    },
    showPreview($event) {
      this.imgShow = true;
      ImagePreview({ images: [$event.target.src] });
    },
  },
};
</script>

<style lang="scss">
.progress_box {
  .toggle {
    width: 100%;
  }
  .progress {
    width: 335px;
  }
}
</style>
<style scoped lang="scss">
.fruitDetail {
  margin: 0;
  padding: 0;
  width: 100%;
  height: auto;
  background-color: #fff8d6;
  padding-bottom: 25px;
  overflow: hidden;
  /* 页面banner区 */
  .banner {
    position: relative;
    width: 100%;
    height: 190px;
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  /* 文章详情页 */
  .main {
    height: auto;
    margin-bottom: 0px;
    .main_contents {
      padding: 23px 15px 0;
      width: 100%;
      box-sizing: border-box;
      .main_contents_header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0 10px 15.5px;
        align-items: center;
        border-bottom: 1px dashed rgba(230, 0, 18, 0.2);
        .main_contents_header_title {
          font-size: 18px;
          line-height: 1.2;
          color: #333333;
          font-weight: 800;
          margin-bottom: 12.5px;
          text-align: center;
        }
        .main_contents_header_info {
          display: flex;
          justify-content: space-between;
          font-size: 10px;
          letter-spacing: 0.5px;
          color: #9d9a8d;
          // width: 170px;
          margin: 0 auto;
        }
      }

      .main_contents_box {
        padding: 22px 0 22px;
        font-size: 16px;
        line-height: 1.5;
        letter-spacing: 0.5px;
        color: #666666;
        border-bottom: 1px dashed rgba(230, 0, 18, 0.2);
        p {
          margin: 0;
          text-align: left;
          background-color: rgba(255, 255, 255, 0) !important;
          /deep/ .edui-upload-video {
            display: block;
            width: 100%;
          }
          /deep/ img {
            max-width: 100%;
            height:auto
          }
        }
        .edui-upload-video {
          display: block;
          width: 100%;
        }
      }
    }
  }
  /* 党员群众有话说 */
  .people_talks {
    position: relative;
    width: 344px;
    background-color: #ffd4cc;
    box-shadow: 2px 3.5px 2.5px 0px rgba(230, 0, 18, 0.12);
    border-radius: 10px;
    margin: 20px auto;
    padding: 0 10px 25px;
    box-sizing: border-box;
    .people_talks_bg1 {
      position: absolute;
      left: 0;
      top: 0;
    }
    .people_talks_bg2 {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 100%;
      z-index: 0;
    }

    .party_talks_title {
      padding-bottom: 29px;
      width: 100%;
      font-size: 17px;
      font-weight: 800;
      color: #e60012;
      text-align: center;
      padding: 18px 0 0;
    }

    .people_talks_box {
      position: relative;
      z-index: 1;
      display: flex;
      margin-bottom: 0;
      .people_avatars {
        position: relative;
        margin-top: 15px;
        .people_avatar {
          width: 33px;
          height: 33px;
          border-radius: 50%;
        }
        .people_party {
          position: absolute;
          right: -0.5px;
          top: -0.5px;
          width: 11px;
          height: 11px;
        }
      }
      .people_talks_words {
        text-align: left;
        .people_name {
          display: inline-block;
          font-size: 13px;
          line-height: 20.5px;
          color: #666666;
          width: 100%;
        }
        .people_texts {
          font-size: 13px;
          line-height: 1.4;
          letter-spacing: 0.5px;
          color: #999999;
          font-weight: 400;
          width: 239px;
          background-color: #ffffff;
          box-shadow: 1px 2px 8px 0px rgba(230, 0, 18, 0.12);
          border-radius: 5px;
          padding: 9px;
          box-sizing: border-box;
        }
      }
    }
    .people_talks_box.people_talks_left {
      justify-content: flex-start;
      .people_avatars {
        margin-right: 7.5px;
      }
    }

    .people_talks_box.people_talks_right {
      justify-content: flex-end;
      .people_avatars {
        margin-left: 7.5px;
      }
      .people_name {
        text-align: right;
      }
    }

    .people_talks_box:last-child {
      margin-bottom: 0;
    }
  }
  /* 心愿完成过程 */
  .progressTitle {
    font-size: 17px;
    line-height: 20.5px;
    color: #e60012;
    font-weight: 800;
    text-align: center;
    padding: 25px 0;
    margin: 0 15px;
    box-sizing: border-box;
    border-top: 1px dashed rgba(229, 0, 18, 0.3);
  }
  .progress_box {
    width: 335px;
    border-radius: 10px;
    margin: 0 auto 28px;
    border: solid 1px #e4806f;
    border-top: 0;
    border-radius: 10px;
    padding-bottom: 30px;
  }
  /* 评论区 */
  .list_comments {
    width: 100%;
    height: auto;
    border-radius: 10px;
    padding: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
    margin-top: 20px;
    background-color: #fff;
    border-radius: 20px 20px 0 0;
    .list_comments_header {
      img {
        width: 72px;
      }
    }
  }
  .moreComment {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px;
    span {
      font-size: 14px;
      letter-spacing: 1px;
      color: #555;
      margin-right: 4px;
      line-height: 1;
    }
    img {
      width: 6px;
      vertical-align: middle;
    }
  }
}
.wish {
  position: relative;
  width: 345px;
  background-color: #ffffff;
  box-shadow: 1px 2px 6px 0px rgba(230, 0, 18, 0.1);
  border-radius: 8px;
  z-index: 1;
  margin: -49px auto 0;
  padding-bottom: 15px;

  .review_top {
    display: flex;
    padding: 9.5px 15px 0 10px;
    align-items: center;
    .review_left {
      width: 33px;
      height: 33px;
      img {
        width: 33px;
        height: 33px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    .review_right {
      width: 56px;
      height: 7.5px;
      font-size: 10px;
      line-height: 11.5px;
      color: #666666;
      opacity: 0.7;
    }
    .review_center {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-left: 4px;
      text-align: left;
      .review_name {
        font-size: 18px;
        line-height: 1;
        color: #666666;
        margin-top: 2px;
        margin-bottom: 4px;
      }
      .review_address {
        font-size: 10px;
        line-height: 1;
        color: rgba(102, 102, 102, 0.7);
      }
    }
    .review_time {
      font-size: 10px;
      color: rgba(102, 102, 102, 0.7);
    }
  }
  .review_main {
    width: 284px;
    font-size: 16px;
    line-height: 1.4;
    letter-spacing: 0.5px;
    color: #666666;
    margin-left: 47.5px;
    text-align: left;
    margin-top: 10px;
  }
  .review_bottom {
    width: 283px;
    height: 55px;
    display: flex;
    justify-content: space-between;
    margin-left: 48px;
    margin-top: 8px;
    img {
      width: 91px;
      height: 55px;
      object-fit: cover;
      border-radius: 5px;
    }
  }
}
</style>
